import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { menuView ,routesView} = Views;

const systemAdministrationRouter = {
  path: "/system-administration",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "menu",
      name: "Menu",
      component: menuView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "routes",
      name: "Routes",
      component: routesView,
      meta: {
        requiresAuth: true,
      },
    }

  ],
};

export default systemAdministrationRouter;
